WAU.Quickshop = {
  init: function init() {

    var selectors = {
      quickviewButton: '.js-quickview-trigger'
    }

		// Remove section contents
		if ( document.getElementById('quickshopTemplate') ) {
			document.getElementById('quickshopTemplate').innerHTML = '';
		}

    // Init on click event for buttons (only attach once per button to avoid duplicate add-to-cart)
    document.querySelectorAll(selectors.quickviewButton).forEach((button, i) => {
      if (button.dataset.quickshopInited === 'true') return;
      button.dataset.quickshopInited = 'true';

      button.addEventListener('click', function(event) {
        event.preventDefault();
				if (event.target.classList.contains('loading-quickshop')) return;
				event.target.classList.add('loading-quickshop');

				var productUrl = this.dataset.productUrl,
						productUrl = WAU.Quickshop.cleanUrl(productUrl, 'variant');

				let singleVariant = event.target.hasAttribute('data-quick-add');

				const loader = new WAU.Helpers.scriptLoader();

        if ( this.dataset.hasModel )loader.load([jsAssets.productModel]).finally(() => {});
        if ( this.dataset.hasVideo )loader.load([jsAssets.productVideo]).finally(() => {});
        if ( this.dataset.productPickupAvailability )loader.load([jsAssets.productPickupAvailability]).finally(() => {});

				loader.load([jsAssets.flickity]).finally(() => {
					loader.load([jsAssets.product]).finally(() => {
						WAU.Quickshop.getTemplate(productUrl, singleVariant, event.target);
					});
				});

      });
    });

		// Open placeholder product on edit
		document.addEventListener("shopify:section:select", function(event) {
		  if (event.target.id != 'shopify-section-quickshop') return false;

			WAU.Quickshop.getOnboard();

		});
  },
  formatTemplate: function formatTemplate(response) {
		const doc = new DOMParser().parseFromString(response, 'text/html');
    const template = doc.getElementById('quickshopTemplate');
    return template && template.innerHTML ? template.innerHTML : '';
  },
  showModal: function showModal(trigger) {
		trigger.setAttribute('data-wau-modal-target', 'quickview');
		trigger.classList.add('js-modal-open');

		WAU.Modal.init("quickview");
		WAU.Modal._openByName("quickview");
  },
  hideModal: function hideModal() {
		document.querySelector('.js-quickview-content').innerHTML = '';

    WAU.Modal._closeByName("quickview");
  },
	showDrawer: function showDrawer(trigger) {
		trigger.setAttribute('data-wau-slideout-target', 'quickview');
		trigger.setAttribute('data-slideout-direction', 'right');
		trigger.classList.add('js-slideout-open');

		WAU.Slideout.init("quickview");
		WAU.Slideout._openByName("quickview");
	},
	hideDrawer: function hideDrawer() {
		document.querySelector('.js-quickview-content').innerHTML = '';

		WAU.Slideout._closeByName("quickview");
	},
  cleanUrl: function cleanUrl(url, key) {
    return url.split('?')[0] + '?view=quick';
  },
  getTemplate: function getTemplate(url, singleVariant, trigger) {
		var log = typeof console !== 'undefined' && console.log ? function() { console.log.apply(console, ['[Quickshop]'].concat(Array.prototype.slice.call(arguments))); } : function() {};
		log('getTemplate: url=', url);

		fetch(url)
		.then(function(response) {
			log('getTemplate: fetch response status=', response.status);
			return response.text();
		})
		.then(function(response) {
			let content = WAU.Quickshop.formatTemplate(response);
			log('getTemplate: content length=', (content && content.length) || 0, 'has quickshopTemplate=', (response && response.indexOf('id="quickshopTemplate"') !== -1));

      // Replace content
      var contentEl = document.querySelector('.js-quickview-content');
      if (contentEl) contentEl.innerHTML = content || '';

			// Set context; abort if no template was found (e.g. 404)
			const context = document.getElementById('quickview-form');
			if (!content || !context) {
        log('getTemplate: abort - no content or no quickview-form');
        trigger.classList.remove('loading-quickshop');
        return null;
      }

			// Sync section id from loaded content so Product() finds the form (form id = product-form-{productId}-{sectionId})
			var wrapper = context.querySelector('[data-section-id]');
			if (wrapper && wrapper.dataset.sectionId) {
        var loadedSectionId = wrapper.dataset.sectionId;
        if (context.dataset.sectionId !== loadedSectionId) {
          context.dataset.sectionId = loadedSectionId;
          log('getTemplate: synced context data-section-id to', loadedSectionId);
        }
      } else {
        log('getTemplate: no [data-section-id] in loaded content');
      }

			var formWithData = context.querySelector('[data-product-form]');
			var productJsonEl = context.querySelector('.product-json');
			log('getTemplate: context.dataset.sectionId=', context.dataset.sectionId, 'form [data-product-form]=', !!formWithData, 'product-json=', !!productJsonEl);

			return context;
    }).then(context => {
      if (!context) return;

			// Load product js function
      try {
        Product(context);
        log('getTemplate: Product(context) completed');
      } catch (err) {
        log('getTemplate: Product(context) threw', err.message, err);
        throw err;
      }

      if (typeof window.miraiApplyMoneyRoundingToThirdPartyScripts === 'function') {
        window.miraiApplyMoneyRoundingToThirdPartyScripts();
      }

			return context;
    }).then(context => {
      if (!context) return;
			// Load Payment Buttons
      if (context.querySelector('.js-quickview-wrapper')) {
        if (context.querySelector('.js-quickview-wrapper').dataset.paymentButton == 'true' && Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }
      }
			return context;
    }).then(context => {
      if (!context) return;
			// Trigger event for add to cart
			if ( context.querySelector('.js-ajax-submit') ) {
				context.querySelector('.js-ajax-submit').addEventListener('click', function (e) {
					e.preventDefault();

					var addToCartForm = this.closest('form');

					let cartConfig = document.getElementById('cart-config');
					if ( !cartConfig ) return false;
					cartConfig = JSON.parse(cartConfig.innerHTML || '{}');

					WAU.AjaxCart.addToCart(addToCartForm, null, cartConfig, true, false);

					return false;
				});
			}

			return context;
    }).then(context => {
      if (!context) return;

			let type = context.dataset.quickshopType,
				  quickAdd = (context.dataset.quickshopAdd === 'true');

			if ( singleVariant === true) {
				// Add to cart immediately when button is "Add to cart" (data-quick-add), do not open modal/drawer
				var addToCartForm = context.querySelector('.js-product-form-quickshop');

				let cartConfig = document.getElementById('cart-config');
				if ( !cartConfig ) return false;
				cartConfig = JSON.parse(cartConfig.innerHTML || '{}');

				trigger.classList.add('js-quick-adding');

				WAU.AjaxCart.addToCart(addToCartForm, null, cartConfig, true, true, trigger);

        trigger.classList.remove('loading-quickshop');
			} else {
				// Open quick shop
				if ( type === 'modal' ) {
					WAU.Quickshop.showModal(trigger);
				} else {
					WAU.Quickshop.showDrawer(trigger);
				}
        trigger.classList.remove('loading-quickshop');
			}

      [0, 400, 1200].forEach(function (ms) {
        setTimeout(function () {
          if (typeof window.miraiApplyMoneyRoundingToThirdPartyScripts === 'function') {
            window.miraiApplyMoneyRoundingToThirdPartyScripts();
          }
        }, ms);
      });

    })
    .catch(error => {
      console.log(error)
    });
  },
	getOnboard: function getOnboard() {
		let content = document.querySelector('.js-quickview-onboard');
		document.querySelector('.js-quickview-content').innerHTML = content.innerHTML;

		let type = content.dataset.quickshopType,
				trigger = document.querySelector('.js-quickview-onboard-trigger');

		if ( type == 'modal' ) {

			if (document.body.classList.contains('slideout-right--open')) document.body.classList.remove('slideout-right--open');
			WAU.Quickshop.showModal(trigger);

			setTimeout(function() {
				document.getElementById('modal-quickview').style.top = `calc(${window.scrollY}px + 10vh)`;
			}, 500);

		} else {
			if (document.body.classList.contains('modal--open')) document.body.classList.remove('modal--open');
			WAU.Quickshop.showDrawer(trigger);
		}

	}
}

document.addEventListener('DOMContentLoaded', function() {
  WAU.Quickshop.init();
});

document.addEventListener('shopify:section:select', function(event){
  WAU.Quickshop.init();
});
